<template>
  <span>{{current}}/{{max}}</span>
</template>
<script>
export default {
  name: "CharCount",
  props: {
    max: {
      type: Number
    },
    text: {
      type: String
    }
  },
  data() {
    return {
      current: 0
    };
  },
  created() {
    if (this.text) {
      this.current = this.text.length;
    }
  },
  watch: {
    text: function(newValue) {
      if (newValue) {
        this.current = newValue.length;
      } else {
        this.current = 0;
      }
    }
  }
};
</script>
